import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
            Frequently Asked
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52]">
            Questions we hear often
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-${i}`}
              className="border-b border-gray-200"
            >
              <AccordionTrigger className="text-left text-base font-semibold text-[#0F2D52] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-gray-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
